<form class="d-flex justify-content-between multi-select-chips align-items-center mb-6" *ngIf="valueFormGroup && valueFormControl">
  <mat-form-field appearance="outline" floatLabel="auto" class="w-100">
    <label *ngIf="label" for="{{ controlName }}" class="col-12 col-lg-4 col-form-label {{ required ? 'required' : '' }}">{{ label }}</label>
    <div class="col-12 col-lg-8 w-100 d-flex align-items-center flex-wrap {{ class }}" [formGroup]="valueFormGroup">
      {{ resetOptions }}

      <mat-chip-grid class="w-100" #chipList>
        <ng-container *ngIf="!isViewAll.value">
          <mat-chip-row class="chips-customs" *ngFor="let inputSelectInterface of inputSelectInterfaces.slice(0, 2)" (removed)="remove(inputSelectInterface)">
            {{ inputSelectInterface.display }}
            <button matChipRemove>
              <span [inlineSVG]="STRING_CONSTANTS.ICON.IC_MINI_CLOSE"></span>
            </button>
          </mat-chip-row>
        </ng-container>
        <ng-container *ngIf="isViewAll.value">
          <mat-chip-row class="chips-customs" *ngFor="let inputSelectInterface of inputSelectInterfaces" (removed)="remove(inputSelectInterface)">
            {{ inputSelectInterface.display }}
            <button matChipRemove>
              <span [inlineSVG]="STRING_CONSTANTS.ICON.IC_MINI_CLOSE"></span>
            </button>
          </mat-chip-row>
        </ng-container>

        <span class="view-more-btn cursor-pointer d-flex align-items-center ms-1" (click)="onClickViewAll()" *ngIf="inputSelectInterfaces.length > 2 && !isViewAll.value"
          >+ {{ inputSelectInterfaces.length - 2 }} more</span
        >
      </mat-chip-grid>
      <input
        class="input-multiple-select-chips"
        #inputElements
        [placeholder]="placeholder"
        [matAutocomplete]="auto"
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [formControlName]="controlName"
      />
      <span [inlineSVG]="STRING_CONSTANTS.ICON.IC_ARROW_MINI_DOWN" class="me-2"></span>

      <mat-autocomplete class="bg-white border" #auto="matAutocomplete" (optionSelected)="selected($event)">
        <mat-option *ngFor="let inputSelectInterface of inputBehavior.asObservable() | async" [value]="inputSelectInterface">
          <label [for]="'id-select' + inputSelectInterface.value" class="d-flex align-items-center">
            <input class="form-check-input cursor-pointer m-3" type="checkbox" [checked]="checkActiveOptions(inputSelectInterface.value)" />
            {{ inputSelectInterface.display }}
          </label>
        </mat-option>
      </mat-autocomplete>
    </div>
  </mat-form-field>
</form>
